// [CurveBeam] - [BoneVue]

import { OrientationAxis } from '@cornerstonejs/core/dist/esm/enums';

export class BmdViewportRotation {
  viewportName: OrientationAxis;
  /**
   * Rotation in radians
   */
  rotation: number;
}
